import { useQuery } from "@tanstack/react-query";

import { httpRequest } from "@/lib/axios";
import { TimeSchedulingResponse } from "@/types";

type fetchTimeSchedulingsProps = {
  employeesId: string;
  date: string;
};

async function fetchTimeSchedulings({
  date,
  employeesId,
}: fetchTimeSchedulingsProps): Promise<TimeSchedulingResponse> {
  const response = await httpRequest.get<TimeSchedulingResponse>(
    `scheduling/generate-times/${employeesId}/${date}`
  );
  return response.data;
}

export function useFetchTimeSchedulingsQuery({
  date,
  employeesId,
}: fetchTimeSchedulingsProps) {
  const timeSchedulingsQuery = useQuery({
    queryKey: ["availableTimes", date, employeesId],
    queryFn: () => fetchTimeSchedulings({ date, employeesId }),
    keepPreviousData: false,
    enabled: !!(date && employeesId),
  });

  return {
    ...timeSchedulingsQuery,
    data: timeSchedulingsQuery.data,
  };
}
